import { useEffect, useState } from "react";
import { useCreateCompanyUserMutation, useLazyGetCompanyUsersQuery, useUpdateCompanyUserMutation } from "../../services/company";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Form, Table } from "antd";
import { Actions } from "../../shared/constants";
import validateMessages from "../../utils/validate";
import { useLazyGetRolesQuery } from "../../services/role";
import Icon from "../../components/Icon";
import tableUtils from "../../utils/tableUtils";
import { CompanyUsersColumn } from "../../shared/table/columns";
import { LoadingOutlined } from "@ant-design/icons";
import HrnModal from "../../components/HrnModal";
import CompanyUserForm from "./CompanyUserForm";
import { useLazyGetServiceCentersQuery } from "../../services/serviceCenter";

const CompanyUser = ({ companyId, insideTab, presentation, serviceCenters }: {
    companyId?: string | null,
    presentation: "User" | "ServiceMan",
    insideTab?: boolean,
    serviceCenters?: any[]
}) => {
    const routeParams = useParams();
    const navigate = useNavigate();
    const [userForm] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState("");
    const [editData, setEditData] = useState<any>(null);
    const [dataSource, setDataSource] = useState([]);
    const [getRoles, getRolesResult] = useLazyGetRolesQuery();
    const [getUsers, getUsersResult] = useLazyGetCompanyUsersQuery();
    const [getServiceCenters, getServiceCentersResult] = useLazyGetServiceCentersQuery();
    const [createUser, createUserResult] = useCreateCompanyUserMutation();
    const [updateUser, updateUserResult] = useUpdateCompanyUserMutation();
    companyId = companyId || routeParams.companyId;
    useEffect(() => {
        getUsers({ id: companyId }).unwrap();
        getRoles({}).unwrap();
        if (!serviceCenters?.length) {
            getServiceCenters({ companyId }).unwrap();
        }
    }, [companyId]);

    useEffect(() => {
        if (getUsersResult.isSuccess) {
            setDataSource(getUsersResult?.data || []);
        }
    }, [getUsersResult.isFetching]);

    const showModal = () => {
        setMode(Actions.CREATE);
        setOpen(true);
    };

    const hideModal = () => {
        setOpen(false);
    };

    const afterModalClose = () => {
        userForm.resetFields();
        setMode("");
    };

    const handleEdit = (record: any) => {
        setMode(Actions.EDIT);
        setOpen(true);
        if (record.id) setEditData(record);
        userForm.setFieldsValue(record);
    };

    const handleDelete = async (record: any) => {
        // try {
        //   await deleteQuestion({ surveyId: record.surveyId, id: record.id }).unwrap();
        // } catch (e) { }
    };

    const onSave = async () => {
        try {
            await userForm.validateFields();
        } catch (errorInfo) {
            return;
        }

        const formFields = userForm.getFieldsValue();
        if (mode === Actions.CREATE) {
            try {
                await createUser({ id: companyId, body: formFields }).unwrap();
                setOpen(false);
            } catch (e) { }
        } else
            try {
                await updateUser({ id: companyId, userId: editData.id, body: formFields }).unwrap();
                setOpen(false);
            } catch (e) { }
    };

    return (
        <>
            <div className="flex justify-between items-center gap-3 pb-2">
                {!insideTab && <div className="flex gap-x-2 items-center pb-5 sm:pb-9">
                    <Icon
                        icon="arrow_back"
                        className="h-5 w-5 cursor-pointer"
                        onClick={() => navigate(-1)}
                    />
                    <div className="text-headline">Users</div>
                </div>}
                {insideTab && <div></div>}
                <Button type="primary" size="large" onClick={showModal}>
                    <div className="flex items-center gap-1.5">
                        <Icon icon="add" className="h-4.5 w-4.5" />
                        <div>{"Add User"}</div>
                    </div>
                </Button>
            </div>
            <div>
                <Table
                    key={getUsersResult.isFetching ? "loading-done" : "loading"}
                    rowKey="id"
                    columns={tableUtils.buildColumns(
                        dataSource,
                        CompanyUsersColumn,
                        tableUtils.editDeleteActionColumns(handleEdit, handleDelete),
                        [],
                        undefined,
                        { serialNo: true }
                    )}
                    dataSource={dataSource || []}
                    size="middle"
                    className="ant_table"
                    loading={{
                        spinning: getUsersResult.isFetching as boolean,
                        indicator: <LoadingOutlined style={{ fontSize: 34 }} />,
                    }}
                    pagination={false}
                />
            </div>
            <div>
                <HrnModal
                    open={open}
                    title={`${mode === Actions.CREATE ? "Add" : "Edit"} User`}
                    width={520}
                    onCancel={hideModal}
                    onSave={onSave}
                    afterClose={afterModalClose}
                    isLoading={
                        (createUserResult.isLoading
                            || updateUserResult.isLoading
                        ) as boolean
                    }
                >
                    <div className="mt-6">
                        <Form
                            form={userForm}
                            layout="vertical"
                            name="userForm"
                            validateMessages={validateMessages}
                        >
                            <CompanyUserForm
                                mode={mode}
                                presentation={presentation}
                                userForm={userForm}
                                roles={getRolesResult.isSuccess ? getRolesResult?.data : []}
                                serviceCenters={serviceCenters || (getServiceCentersResult.isSuccess ? getServiceCentersResult?.data : [])}
                            />
                        </Form>
                    </div>
                </HrnModal>
            </div>
        </>
    );
};

export default CompanyUser;
